export default "__VITE_ASSET__c7ed7332__"